import bannerMain from "Images/Checklist/Peak_Performance_checklist_MAIN.png";
import bannerFiveOfEight from "Images/Checklist/peak_performance_checklist_5_8.png";
import bannerEightOfEight from "Images/Checklist/peak_performance_checklist_8_8.png";
import { ChecklistBanners, ChecklistItem } from "JS/Models/Checklist";

// Banner thresholds. 5-7 checked shows the 5/8 artwork; 8 shows the 8/8 artwork.
const earlyEntryThreshold = 5;
const raffleThreshold = 8;

export const checklistBanners: ChecklistBanners = {
    main: bannerMain,
    fiveOfEight: bannerFiveOfEight,
    eightOfEight: bannerEightOfEight,
};

export const selectChecklistBanner = (
    banners: ChecklistBanners,
    checkedCount: number,
) => {
    if (checkedCount >= raffleThreshold) return banners?.eightOfEight;
    if (checkedCount >= earlyEntryThreshold) return banners?.fiveOfEight;
    return banners?.main;
};

export const isValidChecklistResponse = (
    items: unknown,
): items is ChecklistItem[] =>
    Array.isArray(items) &&
    items.every(
        (item) =>
            typeof item?.itemNumber === "string" &&
            typeof item?.itemText === "string" &&
            typeof item?.isChecked === "boolean",
    );

export const describeChecklistResponse = (payload: unknown) => {
    if (payload === null || payload === undefined) return "empty body";
    if (Array.isArray(payload)) return "array with unexpected item shape";
    if (typeof payload !== "object") return `unexpected ${typeof payload} body`;

    const { status, message } = payload as {
        status?: unknown;
        message?: unknown;
    };
    return `status=${String(status)} message=${String(message)}`;
};
